// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PathOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PathOffIcon" ref={forwardedRef} {...props}>
      <path d="M4.75 7.5a2.75 2.75 0 0 0 2.563-1.75h6.937v.426l1.32-1.321A1.25 1.25 0 0 0 14.5 4.25H7.455A2.75 2.75 0 1 0 4.75 7.5m0-1.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5" />
      <path d="m15.75 6.795-1.5 1.5V9.25h-.955l-1.5 1.5H14.5a1.25 1.25 0 0 0 1.25-1.25z" />
      <path d="M9.676 10.75H5.75v3.5h.426l-1.321 1.32A1.25 1.25 0 0 1 4.25 14.5v-4A1.25 1.25 0 0 1 5.5 9.25h5.676z" />
      <path d="m6.795 15.75 1.5-1.5h4.393a2.751 2.751 0 1 1-.143 1.5zm9.705-.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" />
      <path d="M3 15.304 15.728 2.576l1.06 1.06L4.062 16.364z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PathOffIcon = /* @__PURE__ */ Object.assign(PathOffIconComponent, {
  displayName: 'PathOffIcon',
});
